var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIvstTdy04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1017_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7012 10.125H4.70117C4.07985 10.125 3.57617 10.6287 3.57617 11.25V21.375C3.57617 21.9963 4.07985 22.5 4.70117 22.5H31.7012C32.3225 22.5 32.8262 21.9963 32.8262 21.375V11.25C32.8262 10.6287 32.3225 10.125 31.7012 10.125Z",
    stroke: "#FF6A16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0137 10.125L24.3887 22.5",
    stroke: "#FF6A16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1387 10.125L32.8262 20.8125",
    stroke: "#FF6A16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57617 11.8125L14.2637 22.5",
    stroke: "#FF6A16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2012 22.5V28.125",
    stroke: "#FF6A16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20117 22.5V28.125",
    stroke: "#FF6A16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1017_6810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.201172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIvstTdy04);
export default __webpack_public_path__ + "static/media/icon-ivst-tdy-04.bfc4aba04e8b2371a356a48991790694.svg";
export { ForwardRef as ReactComponent };